(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["growe-launch-event"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    var video = document.getElementById("myVideo");
    var playIcon = document.getElementById("playIcon");

    if (video && playIcon) {
      // Click on the icon toggles video play/pause
      playIcon.addEventListener("click", function () {
        if (video.paused) {
          video.play();
          playIcon.style.display = "none"; // Hide the icon immediately
        } else {
          video.pause();
          playIcon.style.display = "block"; // Re-show the icon when paused
        }
      });

      // Sync icon with native control pause/play as well
      video.addEventListener("play", function () {
        playIcon.style.display = "none";
      });

      video.addEventListener("pause", function () {
        playIcon.style.display = "block";
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
